import { Injectable } from '@angular/core';
import { CustomTeam } from '@models/team/custom-team';
import { XmMenuItem } from '@optek/xm-bootstrap';
import { UserService } from '@services/user.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { BASEMENU,HIERARCHY, RELEASE_NOTES, RMA, SUPPORT, SWAGGER, TEAMS, TRAINING } from './menu-items';


@Injectable({
  providedIn: 'root'
})
export class NavBarService {
  sidebarMenuItems$: BehaviorSubject<XmMenuItem[]>;
  onMenuItemUpdate$ = new Subject<{ item: XmMenuItem, title: string, parentTitle: string }>();
  showMinisidebar: boolean = true;

  get user() {
    return this.userService.user;
  }

  constructor(
    private userService: UserService,
  ) {
    this.loadMenuData();
    if (window.innerWidth > 1200) {
      this.showMinisidebar = this.userService.userPreferences$.getValue().showMinisidebar;
    }
  }

  loadMenuData() {
    // a user's teams can come from one of two endpoints

    this.sidebarMenuItems$ = new BehaviorSubject<XmMenuItem[]>([
      new XmMenuItem(
        0,
        `${this.user.employee.firstName} ${this.user.employee.lastName}`,
        'icon-account',
        { url: '/profile' }
      ),
      ...this.getMenuItems()
    ]);
  }

  buildTeamMenuItem(team: CustomTeam, idx = 0): XmMenuItem {
    return {
      // this ternary should not be necessary once the API and model for team is aligned.
      position: idx,
      // @ts-ignore ALM-277061
      title: team.teamName ? team.teamName : team.name,
      icon: 'icon-account-multiple',
      route: {
        url: `/team-profile`,
        params: {
          // @ts-ignore ALM-277061
          teamName: team.teamName ? team.teamName : team.name,
          owner: team.owner ? team.owner.employee.username : this.user.employee.username
        }
      },
      subMenuItems: []
    };
  }

  private getMenuItems() {
    let menuItems = [...BASEMENU];
    if(localStorage.getItem('ROLE') == 'FULL')
    {
      menuItems.push(HIERARCHY);
      menuItems.push(TEAMS);

    }
    menuItems.push(SUPPORT);

    // @ts-ignore ALM-277061
    menuItems[menuItems.length - 1].subMenuItems.push(TRAINING);
    // @ts-ignore ALM-277061
    menuItems[menuItems.length - 1].subMenuItems.push(RMA);
    // @ts-ignore ALM-277061
    menuItems[menuItems.length - 1].subMenuItems.push(RELEASE_NOTES);

    // Moved swagger out of the web app
  /*  if (this.userService.user.roles?.includes('SWAGGER') || this.userService.user.privileges?.developer) {
      // @ts-ignore ALM-277061
       menuItems[menuItems.length - 1].subMenuItems.push(SWAGGER);
    }*/

    return menuItems;
  }

  // @ts-ignore ALM-277061
  updateSidebarItemByTitle(item, title, parentTitle) {
    this.onMenuItemUpdate$.next({ item, title, parentTitle });
  }
}

